import { deleteMedia } from '../../../HttpRequests/media'
import fetch from './fetch'
import handleException from '../../../Core/Helpers/handleException'

export default (media) => async (dispatch) => {

  try {

    await deleteMedia({ id: media.id })

    dispatch(fetch())

  } catch(error) {

    handleException(error)

  }

}
